import React, { JSX } from 'react'
import * as S from './styles'

import Loading from '@/components/Loading'

interface FormBoxProps {
  html: JSX.Element
  footer?: JSX.Element | null
  isLoading: boolean
  isResetPasswordScreen?: boolean
  loadingClass: string
}

const FormBox = ({
  html,
  footer,
  isLoading,
  isResetPasswordScreen = false,
  loadingClass
}: FormBoxProps) => {
  const resetPasswordScreenClass = isResetPasswordScreen
    ? 'reset-password-screen'
    : ''

  return (
    <S.FormBoxWrapper className={resetPasswordScreenClass}>
      {!isLoading && footer}
      <S.FormBoxStack className={resetPasswordScreenClass}>
        <S.FormBoxContainer
          id="formBox"
          className={`margin-small ${resetPasswordScreenClass}`.trim()}
        >
          {isLoading ? <Loading className={loadingClass} /> : html}
        </S.FormBoxContainer>
      </S.FormBoxStack>
    </S.FormBoxWrapper>
  )
}

export default FormBox
